import { render, staticRenderFns } from "./SortableHeaderLabel.vue?vue&type=template&id=78b449bc&scoped=true"
import script from "./SortableHeaderLabel.vue?vue&type=script&lang=js"
export * from "./SortableHeaderLabel.vue?vue&type=script&lang=js"
import style0 from "./SortableHeaderLabel.vue?vue&type=style&index=0&id=78b449bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b449bc",
  null
  
)

export default component.exports